var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.campaignId)?_c('os-participant-overview',{staticClass:"minimal-critical-height",attrs:{"participants":_vm.participants,"customer-id":_vm.customerId},on:{"rowclicked":(e) => _vm.rowClicked(e)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }